<template>
  <div>
    <v-row>
      <v-card flat color="#f3f5f8" width="100%">
      <v-col cols="12">
        <h3 class="titleText--text mb-3">Model Statistics</h3>
          <v-simple-table fixed-header dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left titleText--text font-weight-bold">R<sup>2</sup></th>
                  <th class="text-left titleText--text font-weight-bold">adj_rsquared</th>
                  <th class="text-left titleText--text font-weight-bold">mape</th>
                  <th class="text-left titleText--text font-weight-bold">dw</th>
                  <th class="text-left titleText--text font-weight-bold">aic</th>
                  <th class="text-left titleText--text font-weight-bold">bic</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in getstatisticsdata()" :key="item.region">
                  <td class="titleText--text font-weight-bold ">{{ new Intl.NumberFormat('en').format(item.rsquared) }}</td>
                  <td class="titleText--text font-weight-bold">{{ new Intl.NumberFormat('en').format(item.adj_rsquared) }}</td>
                  <td class="titleText--text font-weight-bold">{{ new Intl.NumberFormat('en').format(item.mape) }}</td>
                  <td class="titleText--text font-weight-bold">{{ new Intl.NumberFormat('en').format(item.dw) }}</td>
                  <td class="titleText--text font-weight-bold">{{ new Intl.NumberFormat('en').format(item.aic) }}</td>
                  <td class="titleText--text font-weight-bold">{{ new Intl.NumberFormat('en').format(item.bic) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- {{ this.itemlistmodel_statistics }}-->
        </v-col>
      </v-card>
    </v-row>
    <v-row>
      <v-card flat color="#f3f5f8" width="100%" class="mt-5">
        <v-col>
          <h3 class="titleText--text mb-3">Model Coefficients</h3>
          <v-simple-table fixed-header dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left titleText--text font-weight-bold">Variable_Name</th>
                  <th class="text-left titleText--text font-weight-bold">Coefficient</th>
                  <th class="text-left titleText--text font-weight-bold">Previous_Coefficient</th>
                  <th class="text-left titleText--text font-weight-bold">Coefficient_Difference</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in getcoefficientsdata()" :key="item.region">
                  <td class="titleText--text font-weight-bold">{{ item.Variable_Name }}</td>
                  <td class="darkGrey--text font-weight-bold">{{ new Intl.NumberFormat('en').format(item.Coefficient) }}</td>
                  <td class="darkGrey--text font-weight-bold">{{ new Intl.NumberFormat('en').format(item.Previous_Coefficient) }}</td>
                  <td class="darkGrey--text font-weight-bold">{{ new Intl.NumberFormat('en').format(item.Coefficient_Difference) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          </v-col>
      </v-card>
        </v-row>
    <v-row>
      <v-card flat color="#f3f5f8" width="100%" class="mt-5">
        <v-col>
          <h3 class="titleText--text">Actual vs Predicted</h3>
          <CtrlChartview ref="ctrlChartview"></CtrlChartview> 
          </v-col>
      </v-card>
      </v-row>
    <v-row>
      <v-card flat color="#f3f5f8" width="100%" class="mt-5">
        <v-col> 
          <h3 class="titleText--text">Sales Volume given by each variable over the period</h3>
          <CtrlChartAreaview ref="ctrlChartAreaview"></CtrlChartAreaview> 
        </v-col>
      </v-card>
      </v-row>
  </div>
</template>

<script>
import CtrlChartview from "./CtrlRegionalModelMixChart.vue";
import CtrlChartAreaview from "./CtrlRegionWiseAreaChart.vue";
export default {
  components: {
    CtrlChartview,
    CtrlChartAreaview,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    divvalue: {
      type: String,
      default: "",
    },

    statisticsdata: [],
    coefficientsdata: [],
    actualpredictedchartdata: [],
    actualpredictedchartAreaChartdata: [],
    volume_area_chart: [],
  },
  data: () => ({
    aic: "",
    divtitle: null,
  }),
  methods: {
    Refresh() {
      alert(this.title);
      alert("refreshdwdata");
      //this.getaic();
    },
    getvalfordiv() {
      return this.statisticsdata[0].rsquared;
    },
    getcoefficientsdata() {
      return this.coefficientsdata;
    },
    getstatisticsdata() {
      return this.statisticsdata;
    },
  },
  mounted() {
    this.divtitle = this.title;
  },
  watch: {
    divtitle: function (val) {
      // alert('Onoad -' + val);
      if (val) {
        // alert('change -' + val);
        this.$refs.ctrlChartview.Refresh(this.actualpredictedchartdata);
        this.$refs.ctrlChartAreaview.Refresh(this.volume_area_chart);
        //this.$refs.ctrlChartview.divvaluelist=this.actualpredictedchartdata;
      }
    },
  },
};
</script>

<style scoped>
headerbox {
  font-weight: bold;
  font-style: italic;
  font-size: 20px;
  color: gray;
}

.headerboxtitle {
  font-size: 20px;
  color: gray;
  text-align: center;
  font-style: italic;
  font-weight: bold;
}

.card4 {
  background-color: #3c8dbc;
  color: white;
  height: 100%;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row) {
  border-color: white !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  border-color: white !important;
  background-color: white !important;
}
</style>
